/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiagnosisClassificationEnum } from './diagnosisClassificationEnum';
import { DiagnosisCertaintyEnum } from './diagnosisCertaintyEnum';


/**
 * Adds or changes a diagnosis; written back to Creator. Expects the patient in the context.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientDiagnosisWrite { 
    icd10Code: number;
    classification: DiagnosisClassificationEnum;
    certainty: DiagnosisCertaintyEnum;
    appointment?: number | null;
    ignoreWarnings?: boolean;
}
export namespace PatientDiagnosisWrite {
}

export const PatientDiagnosisWrite_icd10Code_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosisWrite_classification_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosisWrite_certainty_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientDiagnosisWrite_appointment_Validators: ValidatorFn[] =
    [ ];

export const PatientDiagnosisWrite_ignoreWarnings_Validators: ValidatorFn[] =
    [ ];


